<template>
  <div class="[ min-h-screen min-w-[768px] ]">
    <router-view v-if="appState === 'IDLE'" />
    <div class="[ flex justify-center items-center h-screen ]" v-else>
      <template v-if="appState === 'LOADING'">
        <JBLoadingSpinner :message="loadingMessage" />
      </template>
      <template v-else>
        <div class="flex flex-col gap-4 items-center max-w-[400px] text-center">
          <p>We weren't able to log you in. Please try again.</p>
          <Button @click="forceLogin">Return to login</Button>

          <div class="[ text-center mt-10 ]">
            <p class="[ font-bold ]">Having difficulty logging in?</p>
            <p>Speak to your team leader</p>
          </div>
        </div>
      </template>
    </div>
  </div>

  <Toast />
  <JBConfirmDialog />
</template>

<script setup lang="ts">
import { Button, Toast, useToast } from "primevue";
import JBLoadingSpinner from "@/components/ui/JBLoadingSpinner.vue";
import { useAuthStore } from "@/store/auth.ts";
import { useRouter } from "vue-router";
import { setPageMeta } from "@/utils/page.ts";
import { onMounted, watch } from "vue";
import JBConfirmDialog from "@/components/ui/modals/JBConfirmDialog.vue";
import { setBreadcrumbs } from "@/utils/breadcrumb.ts";
import { storeToRefs } from "pinia";
import { useAppStore } from "./store/app";

const authStore = useAuthStore();

const router = useRouter();
const toast = useToast();

const appStore = useAppStore();

const { appState, loadingMessage } = storeToRefs(appStore);

onMounted(() => {
  appStore.start();
});

watch(
  router.currentRoute,
  (route) => {
    setPageMeta({
      title: String(route.meta.title || ""),
    });

    setBreadcrumbs({ crumbs: [] });

    if (Object.keys(route.query).includes("unauthorized")) {
      toast.add({
        life: 5000,
        severity: "error",
        summary: "Unauthorized",
        detail: "Sorry, you are not permitted to access the requested resource",
      });

      router.replace({ query: {} });
    }
  },
  { immediate: true },
);

async function forceLogin() {
  await authStore.logout();
}
</script>

<style lang="scss">
@use "styles/style.scss";
</style>
